import React, { useEffect, useState } from "react";
import styled from "styled-components";

const RadioBox = styled.div`
    /* height: 52px; */
    border-radius: 13px;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 14px 0px #00266F11;
    margin-bottom: 8px;
    /* padding: 0px 16px; */
    color: #505050;
    font-size: 15px;
    font-weight: 400;
    line-height: 22.43px;
    text-align: left;
    cursor: pointer;

    &.active {
        color: #25368D;
    }

    &.disable {
        cursor: default;
    }

    .circle {
        width: 20px;
        min-width: 20px;
        height: 20px;
        margin-left: 1px;
        margin-right: 12px;
        border-radius: 50%;
        border: 1px solid #505050;

        &.active {
            width: 13px;
            min-width: 13px;
            height: 13px;
            margin-left: 0px;
            margin-right: 12px;
            border: 5px solid #FBE250
        }
    }

    .main-box {
        width: calc(100% - 32px);
        min-height: 46px;
        padding: 4px 16px;
    }
`;

const TextAreaBox = styled.textarea`
    width: calc(100% - 48px);
    resize: none;
    padding: 8px;
    margin: 0px 16px 8px 16px;
    border-radius: 8px;
    border: 1px solid #FBE250;
    color: #25368D;
    font-size: 16px;
    font-weight: 400;
`;

function RadioComponent({
    list,
    value,
    disable,
    labelError,
    isError,
    onSelect,
}) {
    const [selectValue, setSelectValue] = useState(null)

    useEffect(() => {
        setSelectValue(value)
    }, [value])

    function handleSelect(param) {
        if (disable) return;
        setSelectValue(param)
        onSelect && onSelect(param);
    }
    function handleInput(event, param) {
        const _value = event.target.value;
        if (disable) return;
        let detail = { ...param }
        detail.descriptionValue = _value;
        setSelectValue(detail)
        onSelect && onSelect(detail);
    }

    return (
        <div>
            {list?.map((_value, index) => {
                return (
                    <RadioBox key={index} className={`${selectValue?.value === _value.value ? "active" : ""} ${disable ? "disable" : ""}`}>
                        <div className="vertical-center main-box" onClick={() => handleSelect(_value)}>
                            <div className={`circle ${selectValue?.value === _value.value ? "active" : ""}`}></div>
                            {_value.label || _value.value || ""}
                        </div>
                        {(selectValue?.value === _value.value && _value.description) &&
                            <TextAreaBox
                                rows={4}
                                placeholder="กรุณาระบุ"
                                value={selectValue?.value === _value.value ? selectValue.descriptionValue : ""}
                                disabled={disable}
                                onInput={(e) => handleInput(e, _value)}
                            />
                        }
                    </RadioBox>)
            })}
        </div>
    )
}

export default RadioComponent;